import { render, staticRenderFns } from "./LeadCallsTags.vue?vue&type=template&id=42f050d0&scoped=true"
import script from "./LeadCallsTags.vue?vue&type=script&lang=js"
export * from "./LeadCallsTags.vue?vue&type=script&lang=js"
import style0 from "./LeadCallsTags.vue?vue&type=style&index=0&id=42f050d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f050d0",
  null
  
)

export default component.exports